import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { AreaChart, Area, Tooltip, ResponsiveContainer, YAxis } from "recharts";

const UserStats = ({ seletedGymId }) => {
  const [userStats, setUserStats] = useState({
    data: [],
    totalUsers: 0,
  });

  const getData = async (gymId) => {
    try {
      const resp = await get(
        `${endpoints.gym}/week?filter=saved&timePeriod=week&id=${gymId}`
      );
      if (resp?.data?.success) {
        const dataList = resp?.data?.data || [];
        const counts = dataList.map((item) => item.count);
        const totalUsers = counts.reduce((acc, curr) => acc + curr, 0);

        setUserStats({
          data: counts,
          totalUsers,
        });
      }
    } catch (error) {
      console.error("Error fetching user stats:", error);
    }
  };

  useEffect(() => {
    seletedGymId != "" && getData(seletedGymId);
  }, [seletedGymId]);

  const chartData = userStats.data.map((count, index) => ({
    name: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][index],
    uv: count,
  }));

  const CustomCursor = (props) => {
    const { points, height, yDomain } = props;
    const { x, y } = points[0];

    // Ensure yDomain is defined
    const maxY = yDomain && yDomain[1] ? yDomain[1] : height;

    const lineHeight = height - y * (height / maxY);

    return (
      <g>
        {/* Dotted vertical line */}
        <line
          x1={x}
          y1={0}
          x2={x}
          y2={lineHeight}
          stroke="#CCCCCC"
          strokeWidth={1}
          strokeDasharray="4 4"
        />
        <circle cx={x} cy={y} r={5} fill="#3BABA6" />
      </g>
    );
  };

  return (
    <Card
      className="users-card rounded-4 mb-2 hide-scrollbar"
      style={{ height: "300px", marginBottom: 0 }}
    >
      <CardBody className="d-flex flex-column justify-content-between align-items-stretch h-100">
        <div>
          <CardTitle
            tag="h5"
            className="ff-sora font-size-16 primary-black fw-normal"
          >
            Saved
          </CardTitle>
          <p className="light-black ff-sora font-size-14 fw-normal mb-0">
            Saved by users this week
          </p>
          <p className="primary-black ff-sora font-size-24 fw-bold mb-4">
            {userStats.totalUsers}
          </p>
        </div>

        <ResponsiveContainer height={100}>
          <AreaChart data={chartData}>
            <Tooltip cursor={<CustomCursor />} />
            <YAxis hide />
            <Area
              type="monotone"
              dataKey="uv"
              stroke="#F5F5F5"
              fill="#F5F5F5"
              fillOpacity={0.8}
            />
          </AreaChart>
        </ResponsiveContainer>

        <div className="d-flex justify-content-between align-items-end flex-nowrap">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
            (day, index) => (
              <p
                key={index}
                className="light-black font-size-14 fw-normal ff-sora mb-0"
              >
                {day}
              </p>
            )
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default UserStats;
